import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@RHCommerceDev/utils/cn";
import RHCloseIcon from "@RHCommerceDev/icon-close";

const Dialog = DialogPrimitive.Root;

const DialogTrigger = DialogPrimitive.Trigger;

const DialogPortal = DialogPrimitive.Portal;

const DialogClose = DialogPrimitive.Close;

const DialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    className={cn("fixed inset-0 z-[1300] bg-gray-500/40", className)}
    ref={ref}
    {...props}
  />
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Content
    className={cn(
      "fixed inset-0 left-[50%] top-[50%] z-[1300] flex h-fit w-fit translate-x-[-50%] translate-y-[-50%] flex-col overflow-y-auto bg-rh-buff shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)]",
      className
    )}
    ref={ref}
    {...props}
  />
));
DialogContent.displayName = DialogPrimitive.Content.displayName;

const DialogTitle = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Title>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn("sticky top-0 flex h-12 items-center", className)}
    {...props}
  >
    {children}
    <DialogClose className="ml-auto p-0" data-testid="dialog-close-button">
      <RHCloseIcon className="h-4 w-4" />
    </DialogClose>
  </DialogPrimitive.Title>
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;

const DialogDescription = DialogPrimitive.Description;

export {
  Dialog,
  DialogTrigger,
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogDescription
};
